import { render, staticRenderFns } from "./Observations.vue?vue&type=template&id=56480408&scoped=true&"
import script from "./Observations.vue?vue&type=script&lang=js&"
export * from "./Observations.vue?vue&type=script&lang=js&"
import style0 from "./Observations.vue?vue&type=style&index=0&id=56480408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56480408",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VFileInput,VRow,VTextField})
